export default __webpack_public_path__ + "static/pimg1-782782ca9a9c309df11b7c4e7a23fa98.jpg";